import React from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import { Col, Container, Row } from "react-bootstrap";
import "./styles/home.css";
import HomeProfileCard from "./components/HomeProfileCard";
import HomeStatisticsCard from "./components/HomeStatisticsCard";
import HomeOrderListCard from "./components/HomeOrderListCard";
import HomeListingCard from "./components/HomeListingCard";
import HomePayoutSettingCard from "./components/HomePayoutSettingCard";
import GaugeChartCard from "./components/HomeGuageChartCard";
import { useGetUserProfileQuery } from "../../rtk-query/slices/profile/profileSlice";
import { useGetDashboardListingQuery } from "../../rtk-query/slices/dashboard/dashboard-slice";
import DashboardHeader from "../../components/DashboardHeader";
import HomeRedeemCard from "./components/HomeRedeemCard";

function HomeMain() {
  const { data: userProfile } = useGetUserProfileQuery();
  const { data: dashboardListings } = useGetDashboardListingQuery();
  const navigate = useNavigate();
  const getNextMonthDate = () => {
    let currentDate = new Date(); // Ensure it's a valid Date object
    currentDate.setMonth(currentDate.getMonth() + 1); // Add 1 month

    // Format date as YYYY-MM-DD
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
    const day = String(currentDate.getDate()).padStart(2, "0"); // Ensure two-digit day

    return `${year}-${month}-${day}`;
  };
  return (
    <div className="ob-page-main-wrapper">
      <DashboardHeader />
      <Container fluid className="dod-dash-main-page-dashboard p-0">
        <Row>
          <Col xl="9" className="p-md-4">
            <Row className="dod-dash-main-page-header mb-3">
              <div className=" w-100 d-flex flex-wrap align-items-center  justify-content-between">
                <h2 className="ob-supplier-content-heading m-0 p-0">
                  Dashboard
                </h2>
                <div className="d-flex flex-wrap align-items-center gap-3 w-max">
                  <button
                    onClick={() => navigate("/bookings?quickFilters=today")}
                    className="ddmpc-stat-btn  ddmpc-stat-btn-active"
                  >
                    {" "}
                    Today
                  </button>
                  <button
                    onClick={() =>
                      navigate("/bookings?quickFilters=next_7_days")
                    }
                    className="ddmpc-stat-btn "
                  >
                    Week
                  </button>
                  <button
                    onClick={() =>
                      navigate(`/bookings?date=${getNextMonthDate()}`)
                    }
                    className="ddmpc-stat-btn "
                  >
                    Month
                  </button>
                </div>
              </div>
            </Row>
            <div className="d-flex gap-lg-4  gap-0 flex-lg-nowrap flex-wrap">
              <div className="flex-2 flex-shrink-0">
                <HomeRedeemCard userProfile={userProfile?.data} />
              </div>
              <div className="flex-2 d-lg-none d-flex ms-lg-0 ms-sm-4 ">
                <GaugeChartCard
                  dashboardListings={dashboardListings}
                  userProfile={userProfile?.data}
                />
              </div>
              <div className="flex-1">
                <HomeStatisticsCard
                  dashboardListings={dashboardListings}
                  userProfile={userProfile?.data}
                />
              </div>
              <div className="flex-2 d-lg-flex d-none">
                <GaugeChartCard
                  dashboardListings={dashboardListings}
                  userProfile={userProfile?.data}
                />
              </div>
            </div>
            <Row>
              <HomeOrderListCard dashboardListings={dashboardListings} />
            </Row>
          </Col>
          <Col xl="3" className="bg-white">
            <HomeListingCard dashboardListings={dashboardListings} />
            <HomePayoutSettingCard />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HomeMain;
